import * as React from 'react';
import { jsx, css, keyframes } from '@emotion/react';
import { mediaQueries, autoResponsiveClamp } from 'Src/me/pages/guest/proposals/new/React/viewHelpers';
import { setTime, wait } from 'Src/me/pages/guest/proposals/new/utils';

const { tablet, mobile } = mediaQueries();

type BalloonPropsType = {
  balloonContents: React.ReactNode;
};

export const Balloon = ({
  balloonContents,
}: BalloonPropsType) => {
  return (
    <div
      css={css`
        color: #136f84;
        font-size: 14px;
        text-align: center;
        white-space: nowrap;
        min-width: 50px;
        padding: 6px 4px;
        background-color: #aef1ff;
        border-radius: 6px;
        filter: drop-shadow(0 1px 4px rgb(0 0 0 / 0.6));
        position: absolute;
        bottom: calc(100% - 17px);
        right: 10px;
        opacity: 0;
        visibility: hidden;
        animation: ${setTime(0.4)}s ${setTime(3)}s forwards ${keyframes`
          from {
            opacity: 0;
            visibility: hidden;
            bottom: calc(100% - 17px) ;
          }

          to {
            opacity: 1;
            visibility: visible;
            bottom: calc(100% - 7px) ;
          }
        `};
        pointer-events: none;

        ${tablet(() => css`
          transform: translateZ(0);
        `)}

        ${mobile(({ setAutomaticDesignBasedSize }) => css`
          font-size: ${setAutomaticDesignBasedSize(14, 14)};
          min-width: ${setAutomaticDesignBasedSize(50, 50)};
          padding: ${setAutomaticDesignBasedSize(6, 6)} ${setAutomaticDesignBasedSize(4, 4)};
        `)}

        &::before {
          content: "";
          width: 16px;
          height: 10px;
          clip-path: polygon(100% 0, 0 0, 50% 100%);
          background-color: #aef1ff;
          position: absolute;
          top: calc(100% - 1px);
          left: 50%;
          transform: translateX(-50%);

          ${mobile(({ setAutomaticDesignBasedSize }) => css`
            width: ${setAutomaticDesignBasedSize(16, 16)};
            height: ${setAutomaticDesignBasedSize(10, 10)};
          `)}
        }
      `}
    >
      {balloonContents}
    </div>
  );
};
